var serialiser = {
    read : function(bis, enums) {
        var i = bis.read(), k;

        for (k in enums) {
            var e = enums[k];
            
            if (e === i || e.id !== undefined && e.id === i) {
                return e;  
            }
        }
        
        throw new Error("Unable to decode enum value " + i);
    },
    write : function(bos, val) {
        if (val.id) {
            bos.write(val.id);
        } else {
            bos.write(val);
        }
    }
};

module.exports = serialiser;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/serialisers/byte-encoded-enum-serialiser.js
// module id = 39
// module chunks = 1